import { render } from "./OTPInput.vue?vue&type=template&id=0ccfdb83&scoped=true"
import script from "./OTPInput.vue?vue&type=script&lang=js"
export * from "./OTPInput.vue?vue&type=script&lang=js"

import "./OTPInput.vue?vue&type=style&index=0&id=0ccfdb83&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2152951365/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccfdb83"]])

export default __exports__